import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid';
import { sysGroup } from 'dataSource/lookup';
import { alert } from 'devextreme/ui/dialog';
import React, { Component } from 'react';
import { addURL } from 'redux/actions/url';
import ModalDecisionMenu from 'components/pages/modal/participant/admin/decisionMenu/index';
import { confirmAlert } from 'react-confirm-alert';

class AutoProses extends Component {
    constructor(props) {
        super(props)

        this.dataGridRef = React.createRef()
        this.modalAkasesMenuRef = React.createRef()

        this.columns = [
            {
                type: 'buttons',
                buttons: [
                    'edit',
                    {
                        text: 'Direct Dapen',
                        hint: 'edit',
                        onClick: (e) => {
                            confirmAlert({
                                title: 'Konfirmasi',
                                message: 'Kamu yakin ingin direct dapen ?',
                                buttons: [
                                    {
                                        label: 'Yes',
                                        onClick: async () => {
                                            console.log('Yes')
                                        }
                                    },{
                                        label: 'No',
                                        onClick: async () => {
                                            console.log('No')
                                        }
                                    }
                                ]
                            })
                        }
                    }
                ],
            },
            {
                dataField: 'proses',
                caption: 'Proses',
                alignment:'center',
                columns: [
                    {
                        dataField: 'kode',
                        caption: 'ID'
                    },
                    {
                        dataField: 'description',
                        caption: 'description'
                    },
                ]
            }
        ]
    }

    componentWillMount() {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    loadDummyData = () => {
        let dummyData = [
            {
                id: 1,
                kode: 'P001',
                description: 'Proses 1 Description'
            },
            {
                id: 2,
                kode: 'P002',
                description: 'Proses 2 Description'
            },
            {
                id: 3,
                kode: 'P003',
                description: 'Proses 3 Description'
            },
            {
                id: 4,
                kode: 'P004',
                description: 'Proses 4 Description'
            },
            {
                id: 5,
                kode: 'P005',
                description: 'Proses 5 Description'
            }
        ];

        return dummyData
    }

    refreshDataGrid = () => {
        this.dataGridRef.current.forceRefresh()
    }

    forceRefresh = () => {
        this.dataGridRef.current.forceRefresh(true)
    }

    render() {
        return (
            <div className="container-fluid">
                <h2 className="main-title">Auto Proses</h2>

                <DevExpressDataGrid
                    ref={this.dataGridRef}
                    loadAPI='-'
                    insertAPI='-'
                    updateAPI='-'
                    deleteAPI='-'

                    backendserver={process.env.REACT_APP_BACKEND_ACC}

                    useArraySource={true}
                    ArraySourceData={this.loadDummyData}

                    allowAdding={false}
                    allowDeleting={false}
                    allowUpdating={false}

                    exportExcel={false}
                    exportFileName={"Auto-Proses"}
                    allowExportSelectedData={true}
                    selection={"multiple"}

                    showBorders={true}

                    paging={true}
                    defaultPageSize={10}
                    height={'80vh'}

                    //bagian konfigurasi popup saat insert dan edit record
                    popupTitle={'Auto-Proses'}
                    popupWidth={700} //masukan dalam ukuran pixel
                    popupHeight={500} //masukkan dalam ukuran pixel

                    popupFormLabelLocation='left' //accepted value = top, left, right
                    popupFormMinColWidth={300} // minimum lebar kolom
                    popupFormColCount={3} //jumlah kolom pada form

                    //akhir bagian konfigurasi popup

                    ColumnChooser={true} // set false agar kolom tidak dapat di pindah pindah
                    ColumnFixing={true} // set false agar kolom tidak dapat di freeze

                    FilterRow={true} // set false untuk mematikan fitur filter

                    ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
                    SummaryConfiguration={this.summary}

                    onToolbarPreparing={this.onToolbarPreparing}

                    //contoh konfigurasi kolom
                    //this.columns = [{
                    //    dataField: 'kolom1',
                    //    caption: 'Ini Kolom 1'
                    //}, {
                    //    dataField: 'kolom2',
                    //    caption: 'Ini Kolom 2'
                    //}]
                    // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

                    store={this.props.store} // jangan di edit edit
                />

                <ModalDecisionMenu 
                    ref={this.modalAkasesMenuRef} 
                    store={this.props.store}
                />
            </div>
        )
    }
}

export default AutoProses
